// Display grouping for the success scorecard. Pure (no preact import) so it can
// be unit-tested like the other lib helpers. The backend sends a flat metric
// list tagged by `group`; the view renders the groups in this fixed CD order.

import type { KpiMetric } from "@/api/types";

export const KPI_GROUP_ORDER = ["Nachfrage", "Usability", "Wirkung"] as const;

export interface KpiGroup {
  group: string;
  metrics: KpiMetric[];
}

/** Bucket the flat metric list into groups, in fixed display order. Empty
 * groups are omitted; any unknown group (forward-compat) is appended after the
 * known ones in first-seen order. */
export function groupMetrics(metrics: KpiMetric[]): KpiGroup[] {
  const byGroup = new Map<string, KpiMetric[]>();
  for (const m of metrics) {
    const bucket = byGroup.get(m.group);
    if (bucket) bucket.push(m);
    else byGroup.set(m.group, [m]);
  }

  const ordered: KpiGroup[] = [];
  for (const g of KPI_GROUP_ORDER) {
    const ms = byGroup.get(g);
    if (ms) {
      ordered.push({ group: g, metrics: ms });
      byGroup.delete(g);
    }
  }
  for (const [group, ms] of byGroup) ordered.push({ group, metrics: ms });
  return ordered;
}
